import { Request, Response } from "express"

import log from "../log.js"

export const routeGetOnline = async (_req: Request, res: Response) => {
	log("CORE API is online!")

	res.send(`<h2 style="color: #090;">CORE API is online!</h2>`)
}
